module.exports = __webpack_public_path__ + "img/EDIT.d33e782c.svg";